/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/menu-2056086': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M8.5 10a2 2 0 102 2 2 2 0 00-2-2zm0 7a2 2 0 102 2 2 2 0 00-2-2zm7-10a2 2 0 10-2-2 2 2 0 002 2zm-7-4a2 2 0 102 2 2 2 0 00-2-2zm7 14a2 2 0 102 2 2 2 0 00-2-2zm0-7a2 2 0 102 2 2 2 0 00-2-2z"/>'
  }
})
